<template>
  <splitpanes class="default-theme" style="background-color: white" horizontal >
    <pane min-size="20" size="30">
      <div style="display: inline-flex">
        <!--el-input v-model="formData.code" style="width: 200px" disabled/-->
        <el-select v-model="formData.user_id" style="width: 200px;margin-left: 5px;" placeholder="执行用户" clearable>
          <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button @click="onDebug" style="width: 100px;margin-left: 5px">调试运行</el-button>
      </div>
      <KfJsonEditor style="min-height: 300px;height: 100%;margin-top: 2px;margin-bottom: 5px" placeholder="运行参数，json格式" v-model="formData.json"  ></KfJsonEditor>
    </pane>

    <pane min-size="30" style="background-color: white">
      <KfJsonEditor style="min-height: 500px;height: 100%" placeholder="运行日志" v-model="exeLogs" ></KfJsonEditor>
    </pane>
  </splitpanes>
</template>

<script>
import EventSource from 'eventsource';
import {nanoid} from "nanoid";
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "FrameJavaDebug",
  components: {Splitpanes, Pane},

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.parentData.id,
        code: this.parentData.code,
        user_id: '',
        json: '{}',
        jsonObj:{}
      },
      userList: [],
      activeTab:'console',
      exeLogs: ''
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.userList = await this.$http('sysDsService.getUserAll', {});
    },
    async onDebug() {
      if (!this.formData.id || this.formData.id.length == 0) {
        this.$message.error('程序id为空')
        return;
      }

      this.exeLogs = '';

      //先用post方式保存参数，然后再用get请求，获取动态日志
      try{
        this.formData.jsonObj = JSON.parse(this.formData.json);
      }catch (e) {
        this.$message.error('json格式错误')
        return;
      }

      let requestId = await this.$http('sysDebugService.saveParams', this.formData);
      console.log("requestId=" + requestId)

      let baseUrl = window.location.protocol + '//' + window.location.host + process.env.VUE_APP_AXIOS_BASE_URL;
      let url = baseUrl + `debug/run/` + requestId + "?token=" + localStorage.getItem('token');

      const eventSource = new EventSource(url);
      eventSource.onmessage = (event) => {
        let data = event.data;
        console.log(data)

        this.exeLogs = this.exeLogs + data + "\n";

        if (data === '[DONE]') {
          eventSource.close();
        }

      };
      eventSource.onerror = (error) => {
        //console.error('Error了', error, '====', eventSource.readyState)
        //this.$message.error('执行失败。' + error)
        eventSource.close();
      };

      //this.scrollToBottom()

    }
    /*
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.msgList) {
          this.$refs.msgList.scrollTop = this.$refs.msgList.scrollHeight;
        }
      });

    }*/
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}

.el-main {
  border-right: 2px dotted #ddd;

  .box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}


.el-aside {
  width: 60%;
  display: flex;
  flex-direction: column;

  .empty-tip {
    font-size: 24px;
    color: #ccc;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

.send-box {
  display: flex;
  padding: 20px;
}

.msg-list {
  flex: 1;
  overflow: auto;

  .msg-item {
    display: flex;
    padding: 20px 20px 0 20px;

    .icon {
      width: 50px;
      text-align: center;
    }

    .content-box {
      flex: 1;
      white-space: pre-wrap;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 20px;
    }

    .content-box .content {
      border-radius: 15px;
      padding: 10px;
    }

    .content-box.user {
      display: flex;
      justify-content: flex-end;
    }

    .content-box.user .content {
      background-color: AliceBlue;
    }

    .content-box.assistant {

    }

    .content-box.assistant .content {
      background-color: #F4F4F4;
    }

  }

  .msg-item:last-child .content-box {
    border-bottom: none;
  }
}

</style>